import { EnumPropertyComponent } from '../components/EnumPropertyComponent';
import { PropertySchema } from '../PropertySchema';

export interface EnumConfiguration {
  enum: object | any[];
  formatter: (value: any) => string;
  allowUnknownValues?: boolean;
}

export const EnumPropertySchema = {
  component: EnumPropertyComponent,

  defaultConfiguration: {
    enum: {},
    formatter: (value: any) => value?.toString() ?? '',
  },
};

export const EnumProperty = new PropertySchema<string, EnumConfiguration>('enum', EnumPropertySchema);
